<template>
    <Dialog header="Confirmation" :style="{width: '350px'}" :modal="true" :closable="false">
        <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span>Your session is about to time out</span>
        </div>
        <template #footer>
            <Button label="Logout" icon="pi pi-times" @click="sessionLogout" class="p-button-text"/>
            <Button label="Keep Logged In" icon="pi pi-check" @click="keepSession" class="p-button-text" autofocus />
        </template>
    </Dialog>
</template>
<script>
    export default{
        methods: {
            sessionLogout() {
                this.$emit('sessionLogout');
            },
            keepSession(){
                this.$emit('keepSession');
            }
        }
    }
</script>